export enum PermissionEnum {
    read = 0,
    edit = 1,
    validator = 2,
    organize = 3,
    none = 4,
    common = 5
}